import { ProductType } from 'features/products';

export const getGeneralProductIds = (products: ProductType[]): string[] =>
  products.filter((p) => p?.source?.toUpperCase() !== 'PIM').map((p) => p.productId);
